<template>
  <div v-if="currentUser.superAdmin">
    <v-data-table
      :headers="headers"
      :items="recommendedShops"
      :options.sync="pagination"
      :server-items-length="totalRecommendedShops"
      :loading="loading"
      :footer-props="{
        'showFirstLastPage':true,
        'items-per-page-options': [10, 20, 50, 100]
      }"
      class="elevation-1"
    >
      <template v-slot:item.allCities="{ item }">
        <v-switch v-model="item.allCities" disabled></v-switch>
      </template>
      <template v-slot:item.clear="{ item }">
        <v-avatar v-if="currentUser.superAdmin || (!currentUser.superAdmin && !item.allCities)" color="teal" size="26" rounded>
          <router-link
            :to="{
              name: 'SuggestedForYouEdit',
              params: { suggestedForYouId: item.id }
            }"
          >
            <v-icon dark>mdi-pencil</v-icon>
          </router-link>
        </v-avatar>
      </template>
      <template v-slot:item.add="{ item }">
        <v-avatar v-if="currentUser.superAdmin || (!currentUser.superAdmin && !item.allCities)" color="red darken-4" size="26" rounded>
          <v-icon dark @click="delRecord(item)">mdi-delete</v-icon>
        </v-avatar>
      </template>
      <template v-slot:body.prepend>
        <tr>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-spacer></v-spacer>
          </td>
          <td>
            <v-avatar color="indigo" size="30">
              <v-icon
                dark
                @click="
                  page = 1;
                  retrieveRecommendedShops();
                "
                >mdi-magnify
              </v-icon>
            </v-avatar>
          </td>
          <td>
            <router-link :to="{ name: 'SuggestedForYouCreate' }">
              <v-avatar color="teal" size="26" rounded>
                <v-icon dark>mdi-plus</v-icon>
              </v-avatar>
            </router-link>
          </td>
        </tr>
      </template>
    </v-data-table>
    <ConfirmDialog ref="confirm" />
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ConfirmDialog from "@/view/pages/ConfirmDialog";
import {mapGetters} from "vuex";

export default {
  name: "recommendedShops",
  computed: {
    ...mapGetters(["currentUser"]),
    headers(){
      return [
      { text: "Id", align: "start", sortable: true, value: "id" },
      { text: this.$i18n.t('date.from'), value: "startDate" },
      { text: this.$i18n.t('date.to'), value: "endDate" },
      { text: this.$i18n.t('pages.recommendedCategories.allCities'), value: "allCities" },
      { text: this.$i18n.t('commonTable.city'), value: "cityName" },
      { text: this.$i18n.t('pages.sectors.shops'), value: "shopIds" },
      { text: this.$i18n.t('pages.sectors.type'), value: "type" },
      { text: "", value: "search", width: "5%" },
      { text: "", value: "clear", width: "5%" },
      { text: "", value: "add", width: "5%" }
    ]}
  },
  data() {
    return {
      totalRecommendedShops: 0,
      recommendedShops: [],
      defaultRecommendedShops: {
        startDate: "",
        endDate: "",
        cityId: null,
        shopIds: [],
        allCities: true,
        type: "SUGGESTED_FOR_YOU"
      },
      selectedRecommendedShops: {
        startDate: "",
        endDate: "",
        cityId: null,
        shopIds: [],
        allCities: true,
        type: "SUGGESTED_FOR_YOU"
      },
      loading: true,
      pagination: {},
      showEditRecommendedShopsDialog: false,
      citiesList: [],
      shopsList: [],
      dialogDelete: false,
      itemToDelete: null,
      errors: []
    };
  },
  watch: {
    pagination: {
      handler() {
        this.retrieveRecommendedShops();
      },
      deep: true
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Suggested For You" }]);
  },
  components: {
    ConfirmDialog
  },
  methods: {
    async delRecord(item) {
      if (
        await this.$refs.confirm.open(
          this.$i18n.t('common.confirm'),
          this.$i18n.t('pages.suggestedForYou.deleteMessage') +
            item.id +
            " ?"
        )
      ) {
        this.deleteRecord(item);
      }
    },
    deleteRecord(item) {
      this.deleteRecommendedShops(item.id);
    },
    deleteRecommendedShops(recommendedShops) {
      this.loading = true;
      ApiService.delete(`api/recommended-shops/${recommendedShops}`)
        .then(response => {
          this.$log.debug("Recommended shops deleted: ", response);
          this.retrieveRecommendedShops();
        })
        .catch(error => {
          this.$log.error("Error: ", error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    goToEditRecommendedShopsDialog(item) {
      if (item != null) {
        ApiService.get(`api/recommended-shops`, `${item.id}`)
          .then(response => {
            this.$log.debug("Editing recommended shops: ", response.data);
            this.selectedRecommendedShops = response.data;
            this.showEditRecommendedShopsDialog = true;
          })
          .catch(error => {
            this.$log.error("Error: ", error);
            this.errored = true;
          })
          .finally(() => (this.loading = false));
      } else {
        this.emptyShops();
        this.$log.debug(
          "New Suggested for you: ",
          this.defaultRecommendedShops
        );
        this.selectedRecommendedShops = this.defaultRecommendedShops;
        this.showEditRecommendedShopsDialog = true;
      }
    },
    emptyShops() {
      this.defaultRecommendedShops.startDate = "";
      this.defaultRecommendedShops.endDate = "";
      this.defaultRecommendedShops.cityId = null;
      this.defaultRecommendedShops.allCities = true;
      this.defaultRecommendedShops.shopIds = [];
    },
    getRequestParams() {
      let params = {};
      params["type"] = "SUGGESTED_FOR_YOU";

      let sort;
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      if (sortBy.length === 1 && sortDesc.length === 1) {
        sort = sortBy[0];
        if (sortDesc[0] === true) sort += ",desc";
      }
      params["sort"] = sort;
      params["page"] = this.pagination.page;
      params["size"] = this.pagination.itemsPerPage;

      return params;
    },

    retrieveRecommendedShops() {
      const params = this.getRequestParams();
      return new Promise(resolve => {
        this.loading = true;
        ApiService.query("api/recommended-shops", {
          params
        }).then(response => {
          // JSON responses are automatically parsed.
          this.$log.debug("RecommendedShops: ", response.data.content);
          this.recommendedShops = response.data.content;
          this.totalRecommendedShops = response.data.totalElements;
          this.totalPages = response.data.totalPages;
          this.loading = false;
          let title =
            this.totalRecommendedShops != null ? this.totalRecommendedShops : 0;
          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Suggested for you: " + title }
          ]);
          resolve();
        });
      });
    }
  }
};
</script>

<style>
.v-data-table.v-data-table.v-data-table >>> td {
  font-size: 16px;
}

.v-icon.v-icon {
  font-size: 24px !important;
}

tbody tr:nth-of-type(even) {
  background-color: rgba(236, 237, 237);
}

tbody tr:nth-of-type(odd) {
  background-color: rgb(250, 250, 250);
}
</style>
